import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/Bits";
import { ATTRACTIONS, IMG } from "@/data/site";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { MapPin, Trees, GraduationCap, ShoppingBag, Landmark, Fish, Ticket, Building2 } from "lucide-react";

const ICON = {
  Outdoors: Trees, University: GraduationCap, "Shopping & Dining": ShoppingBag,
  History: Landmark, "Lake & Fishing": Fish, Parks: Trees, Shopping: ShoppingBag, Events: Ticket,
};

export default function Attractions() {
  return (
    <>
      <Seo
        title="Things To Do Near Ottawa, KS"
        description="Local attractions near Super 8 Ottawa, Kansas: Prairie Spirit Trail, Ottawa University, downtown Ottawa, Old Depot Museum, Pomona & Hillsdale Lakes, Kanza Park disc golf, plus KU in Lawrence and Baker University in Baldwin City."
        path="/attractions"
        image={IMG.exterior}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Attractions", path: "/attractions" }]}
      />
      <PageHero
        kicker="Local Attractions"
        lines={["Explore", "Franklin", "County"]}
        sub="Trails, lakes, universities and a historic downtown — Ottawa is the perfect basecamp for the whole region."
        image={IMG.exterior}
      />

      <section className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
        <SectionHeader kicker="Nearby" title="Places worth the drive" />
        <p className="mt-4 font-body text-sm text-fog">Drive times are approximate and may vary with traffic and route.</p>
        <div className="mt-14 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {ATTRACTIONS.map((a, i) => {
            const Icon = ICON[a.cat] || Building2;
            return (
              <Reveal key={a.name} i={i % 3} className="group flex h-full flex-col justify-between border-2 border-charcoal bg-paper p-7 transition-colors duration-300 hover:bg-brand-yellow">
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal bg-brand-yellow text-charcoal transition-colors group-hover:bg-charcoal group-hover:text-brand-yellow">
                    <Icon className="h-6 w-6" />
                  </span>
                  <span className="flex items-center gap-1 font-body text-xs font-semibold uppercase tracking-wide text-charcoal/60">
                    <MapPin className="h-3.5 w-3.5" /> {a.dist}
                  </span>
                </div>
                <div className="mt-10">
                  <p className="font-body text-[11px] font-semibold uppercase tracking-wide text-brand-red">{a.cat}</p>
                  <h3 className="mt-1 font-heading text-xl font-black text-charcoal">{a.name}</h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-fog group-hover:text-charcoal/80">{a.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
      <EditorialMarquee items={["Prairie Spirit Trail", "Ottawa University", "Pomona Lake", "Downtown Ottawa"]} />
    </>
  );
}
